<h2>Update your password</h2>
<p>Enter your old password and then choose a new password.</p>

<form [formGroup]="passwordForm">

  <div class="fw-row mt-5">

    <label class="form-label fw-bolder text-dark fs-6">Old Password</label>

    <input class="form-control form-control-solid" type="password" formControlName="password">

  </div>

  <div class="fw-row mt-5">

    <label class="form-label fw-bolder text-dark fs-6">New Password</label>

    <div class="password-container">
      <input
        [type]="getPasswordType()"
        class="form-control form-control-lg form-control-solid"
        id="password"
        formControlName="new_password"
        name="new_password"
        value=""
      />
      <div class="eye-icon" (click)="togglePassword()">
        <i nz-icon nzType="eye" nzTheme="outline"></i>
      </div>
    </div>

  </div>

  <div class="fw-row mt-5">

    <label class="form-label fw-bolder text-dark fs-6">Confirm New Password</label>

    <div class="password-container">
      <input
        [type]="getPasswordType()"
        class="form-control form-control-lg form-control-solid"
        id="confirmpassword"
        formControlName="new_password_confirmation"
        name="new_password_confirmation"
        value=""
      />
      <div class="eye-icon" (click)="togglePassword()">
        <i nz-icon nzType="eye" nzTheme="outline"></i>
      </div>
    </div>

  </div>

</form>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button
    type="button"
    (click)="changePassword()"
    id="qrpay_sign_up_submit"
    [disabled]="
        passwordForm.invalid || ($submitting | async)
      "
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="($submitting | async) === false">
      <span class="indicator-label">Save</span>
    </ng-container>
    <ng-container *ngIf="$submitting | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>
